import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useLimitSwapPair } from '~/state/dex/hooks'

export const SpreadWarningCheck: React.FC<{
  checked: boolean
  setCheck: (value: boolean) => unknown
  usdValueSpread: string
}> = ({ checked, setCheck, usdValueSpread }) => {
  const [inputToken] = useLimitSwapPair()
  const { t } = useTranslation()

  return (
    <StyledSpreadWarningCheck
      htmlFor="limit-order-preview-checkbox"
      onClick={() => setCheck(!checked)}
    >
      <input
        type="checkbox"
        name="limit-order-preview-checkbox"
        checked={checked}
        readOnly
      />
      <span className="checkmark" />
      <span>
        {t('spread_warning_check', {
          spread: `${Math.abs(Number(usdValueSpread))}%`,
          symbol: inputToken?.symbol,
        })}
      </span>
    </StyledSpreadWarningCheck>
  )
}

const StyledSpreadWarningCheck = styled.label`
  color: ${({ theme }) => theme.colors.textDanger};
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: -7px;
  margin-top: 15px;

  input[type='checkbox'] {
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ .checkmark {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  .checkmark {
    width: 14px;
    height: 14px;
    position: relative;
    background: #fafbfc;
    border: 1px solid #eaecf5;
    border-radius: 4px;
    margin-right: 8px;

    &::after {
      content: '';
      position: absolute;
      left: 4.5px;
      top: 2px;
      display: block;
      width: 3.8px;
      height: 7px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`

export default SpreadWarningCheck
